export class PersonalIdentifications {
  static PASSPORT = 'pasport'
  static OTHER = 'other'
  static OTHER_UNLIM = 'other_unlim'
  static INTERN_PASSPORT = 'intern_passport'
  static OTHER_ID = 'other_id'
  static ALIENS_PASSPORT_EST = 'aliens_passport_est'
  static ALIENS_PASSPORT_LAT = 'aliens_passport_lat'
  static TEMPORARY_ID = 'temporary_id'
  static BIRTH_CERTIFICATE = 'birth_certificate'
  static RESIDENCE = 'residence'
  static SERVICE_IDENTITY = 'service_identity'
  static TEMP_RESIDENCE = 'temp_residence'

  static labels = {
    [PersonalIdentifications.PASSPORT]: 'Гражданский паспорт',
    [PersonalIdentifications.OTHER]: 'Национальный паспорт',
    [PersonalIdentifications.OTHER_UNLIM]: 'Внутренний паспорт',
    [PersonalIdentifications.INTERN_PASSPORT]: 'Заграничный паспорт',
    [PersonalIdentifications.OTHER_ID]: 'Внутреннее удостоверение личности',
    [PersonalIdentifications.ALIENS_PASSPORT_EST]: 'Паспорт иностранца',
    [PersonalIdentifications.ALIENS_PASSPORT_LAT]: 'Паспорт негражданина',
    [PersonalIdentifications.TEMPORARY_ID]: 'Временное удостоверение личности',
    [PersonalIdentifications.BIRTH_CERTIFICATE]: 'Свидетельство о рождении',
    [PersonalIdentifications.RESIDENCE]: 'Вид на жительство',
    [PersonalIdentifications.SERVICE_IDENTITY]: 'Служебное удостоверение',
    [PersonalIdentifications.TEMP_RESIDENCE]: 'Разрешение на временное проживание'
  }
}
